import { AccountSettingsState } from "../reducers/accountSettings";

export const getIsAccountSettingsLoaded = (state: AccountSettingsState) => !!state.accountSettings;

export const getAreNotificationRulesEnabled = (state: AccountSettingsState) =>
    state.accountSettings?.AreNotificationRulesEnabled ?? false;
export const getIsCustomSmtp = (state: AccountSettingsState) => state.accountSettings?.IsCustomSMTPEnabled ?? false;
export const getIsSalesAssisted = (state: AccountSettingsState) => state.accountSettings?.IsSalesAssisted ?? false;
export const getGuestRoleId = (state: AccountSettingsState) => state.accountSettings?.GuestRoleId;
export const getDefaultCurrencyId = (state: AccountSettingsState) => state.accountSettings?.DefaultCurrencyId;

export const isNotificationSettingsMenuVisible = (state: AccountSettingsState) =>
    getAreNotificationRulesEnabled(state) || getIsCustomSmtp(state);
